import { render, staticRenderFns } from "./PaymentOrderHeader.vue?vue&type=template&id=ab96cd34"
import script from "./PaymentOrderHeader.vue?vue&type=script&lang=ts"
export * from "./PaymentOrderHeader.vue?vue&type=script&lang=ts"
import style0 from "./PaymentOrderHeader.vue?vue&type=style&index=0&id=ab96cd34&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports